export async function neighborhoodDetailsApi(projectGroupID) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ projectGroupID }),
  };
    const response = await fetch("mysmh/Neighborhood/NeighborhoodDetails", requestOptions);
  return await response.json();
}
